module.exports = __webpack_public_path__ + "static/media/wordpress.e3567337.png";